export default "__VITE_ASSET__19IHag41__"